<template>
  <div class="viewport viewport-with-top-nav viewport-compact">
    <TopNav></TopNav>
    <div class="display-1 my-3">{{ $t('PaymentRedirectPage.makePayment') }}</div>
    <div v-if="loading" class="spinner-fill-page">
       <spinner></spinner>
    </div>
    <template v-else>
      <template v-if="repaymentPartner.redirect">
        <div class="d-flex flex-column text-center align-items-center justify-content-center">
          <div class="avatar avatar-lg mx-auto my-2" :style="'background-image: url(/img/payment/' + repaymentPartner.slug + '.png)'"></div>
          <h3 class="mb-4">{{repaymentPartner.title}}</h3>
          <p class="text-muted-more">{{ $t('PaymentRedirectPage.completeYourRepayment') }}</p>
        </div>
        <a :href="redirectUrl" target="_blank" class="btn btn-lg btn-primary btn-block mt-3">{{ $t('PaymentRedirectPage.openWebsite') }}</a>
      </template>
      <template v-else>
        <h4 class="text-muted">{{repaymentPartner.title}}</h4>
        <p class="text-muted">{{ $t(`PaymentPartners.description.${repaymentPartner.slug}`) }}</p>
        <div class="form-group">
          <label for="loan-reference">{{ $t('PaymentRedirectPage.loanReferenceNumber') }}</label>
          <div class="input-group">
            <input type="text"
                   id="loan-reference"
                   class="form-control"
                   disabled
                   :value="this.reference"
            >
            <div class="input-group-append">
              <button class="btn btn-secondary border-0" @click="copyToClipboard('loan-reference')">{{ $t('PaymentRedirectPage.copy') }}</button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="toBePaid">{{ $t('PaymentRedirectPage.amount') }}</label>
          <div class="input-group">
            <input type="text"
                   id="toBePaid"
                   class="form-control"
                   disabled
                   :value="this.amount"
            >
            <div class="input-group-append">
              <button class="btn btn-secondary border-0" @click="copyToClipboard('toBePaid')">{{ $t('PaymentRedirectPage.copy') }}</button>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="repaymentPartner.iban">
          <label for="iban">{{ $t('PaymentRedirectPage.iban') }}</label>
          <div class="input-group">
            <input type="text"
                   id="iban"
                   class="form-control"
                   disabled
                   :value="repaymentPartner.iban"
            >
            <div class="input-group-append">
              <button class="btn btn-secondary border-0" @click="copyToClipboard('iban')">{{ $t('PaymentRedirectPage.copy') }}</button>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="repaymentPartner.cin">
          <label for="iban">{{ $t('PaymentRedirectPage.cin') }}</label>
          <div class="input-group">
            <input type="text"
                   id="cin"
                   class="form-control"
                   disabled
                   :value="repaymentPartner.cin"
            >
            <div class="input-group-append">
              <button class="btn btn-secondary border-0" @click="copyToClipboard('cin')">{{ $t('PaymentRedirectPage.copy') }}</button>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="repaymentPartner.fiscalCode">
          <label for="fiscalCode">{{ $t('PaymentRedirectPage.fiscalCode') }}</label>
          <div class="input-group">
            <input type="text"
                   id="fiscalCode"
                   class="form-control"
                   disabled
                   :value="repaymentPartner.fiscalCode"
            >
            <div class="input-group-append">
              <button class="btn btn-secondary border-0" @click="copyToClipboard('fiscalCode')">{{ $t('PaymentRedirectPage.copy') }}</button>
            </div>
          </div>
        </div>
        <a v-if="repaymentPartner.url" :href="repaymentPartner.url" target="_blank" class="btn btn-lg btn-primary btn-block mt-3">{{ $t('PaymentRedirectPage.openWebsite') }}</a>
        <div class="flex-grow-1"></div>
      </template>
    </template>
  </div>
</template>

<script>
  import TopNav from '@shared/components/TopNav'
  import ExternalPaymentsMixin from '@/mixins/ExternalPaymentsMixin'
  import PaymentRedirectMixin from '@shared/mixins/PaymentRedirectMixin'

  export default {
    name: 'PaymentRedirectPage',
    components: { TopNav },
    mixins: [ExternalPaymentsMixin, PaymentRedirectMixin],
    data: function () {
      return {
        reference: this.$route.params.id,
        loading: true,
        repaymentPartner: null,
        amount: this.$route.query.amount
      }
    },
    created () {
      if (this.$route.query.method) {
        const slug = this.$route.query.method
        this.repaymentPartner = this.repaymentPartners.filter(x => x.slug === slug)[0]
      }
      this.$http.get(`/api/loans/${this.reference}/`).then(response => {
        if (!this.amount) {
          this.amount = response.data.loan.toBePaid
        }
        this.loading = false
      })
    },
    computed: {
      redirectUrl() {
        return `${document.location.protocol}//${document.location.host}/paynet.htm?amount=${this.amount}&reference=${this.reference}`
      }
    }
  }
</script>
